module.exports = __webpack_public_path__ + "static/media/conference-catering-hero.efa27b3d.jpg";